module.exports = __webpack_public_path__ + "25ad8d1b471db8cc26d864db84a86bd5.ttf";